document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.video-gallery-section .video-slider')) {
    $('.video-gallery-section .video-slider').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1.5,
            variableWidth: true
          }
        }
      ]
    });

    // Video play functionality
    $('.video-gallery-section .video-item').on('click', function (e) {
      e.preventDefault();
      const video = $(this).find('video')[0];
      const playOverlay = $(this).find('.play-overlay');
      const pauseOverlay = $(this).find('.pause-overlay');
      if (video.paused) {
        // Pause all other videos
        $('.video-gallery-section .video-item').not(this).each(function () {
          const otherVideo = $(this).find('video')[0];
          if (!otherVideo.paused) {
            otherVideo.pause();
            $(this).find('.play-overlay').show();
            $(this).find('.pause-overlay').hide();
          }
        });
        video.muted = false;
        video.play().then(() => {
          playOverlay.hide();
          pauseOverlay.show();
        }).catch(error => {
          console.log('Video play failed:', error);
        });
      } else {
        video.pause();
        pauseOverlay.hide();
        playOverlay.show();
      }
    });

    // Ensure play overlay is visible and pause is hidden initially
    $('.video-gallery-section .play-overlay').show();
    $('.video-gallery-section .pause-overlay').hide();
  }
});

 

  // (function() {
  //   'use strict';
  //   const TARGET_SELECTOR = '.custom-cart-redesign .tl__cart-goal__goal-check-point__drawer:nth-child(3) p.tl__cart-goal__goal-check-point-title';
  //   const ORIGINAL_TEXT = 'Free gift';
  //   const REPLACEMENT_TEXT = 'Free gift Cart';
    
  //   function replaceText() {
  //     try {
  //       const element = document.querySelector(TARGET_SELECTOR);
  //       if (element && element.textContent.trim() === ORIGINAL_TEXT) {
  //         element.textContent = REPLACEMENT_TEXT;
  //       }
  //     } catch (error) {
  //       console.error('Error:', error);
  //     }
  //   }
    
  //   replaceText();
  //   if (document.readyState === 'loading') {
  //     document.addEventListener('DOMContentLoaded', replaceText);
  //   }
  //   window.addEventListener('load', replaceText);
    
  //   const observer = new MutationObserver(replaceText);
  //   const cartContainer = document.querySelector('.custom-cart-redesign');
  //   if (cartContainer) {
  //     observer.observe(cartContainer, { childList: true, subtree: true, characterData: true });
  //   }
    
  //   setInterval(replaceText, 2000);
  // })();




  // Box 1 - nth-child(2)
(function() {
  'use strict';
  const TARGET_SELECTOR = '.custom-cart-redesign .tl__cart-goal__goal-check-point__drawer:nth-child(2) p.tl__cart-goal__goal-check-point-title';
  const ORIGINAL_TEXT = 'Shipping discount';
  const REPLACEMENT_TEXT = 'Free Shipping';
  
  function replaceText() {
    try {
      const element = document.querySelector(TARGET_SELECTOR);
      if (element && element.textContent.trim() === ORIGINAL_TEXT) {
        element.textContent = REPLACEMENT_TEXT;
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
  
  replaceText();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceText);
  }
  window.addEventListener('load', replaceText);
  
  const observer = new MutationObserver(replaceText);
  const cartContainer = document.querySelector('.custom-cart-redesign');
  if (cartContainer) {
    observer.observe(cartContainer, { childList: true, subtree: true, characterData: true });
  }
  
  setInterval(replaceText, 2000);
})();

// Box 2 - nth-child(3)
(function() {
  'use strict';
  const TARGET_SELECTOR = '.custom-cart-redesign .tl__cart-goal__goal-check-point__drawer:nth-child(3) p.tl__cart-goal__goal-check-point-title';
  const ORIGINAL_TEXT = 'Free gift';
  const REPLACEMENT_TEXT = 'Free Facemask';
  
  function replaceText() {
    try {
      const element = document.querySelector(TARGET_SELECTOR);
      if (element && element.textContent.trim() === ORIGINAL_TEXT) {
        element.textContent = REPLACEMENT_TEXT;
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
  
  replaceText();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceText);
  }
  window.addEventListener('load', replaceText);
  
  const observer = new MutationObserver(replaceText);
  const cartContainer = document.querySelector('.custom-cart-redesign');
  if (cartContainer) {
    observer.observe(cartContainer, { childList: true, subtree: true, characterData: true });
  }
  
  setInterval(replaceText, 2000);
})();

// Box 3 - nth-child(4)
(function() {
  'use strict';
  const TARGET_SELECTOR = '.custom-cart-redesign .tl__cart-goal__goal-check-point__drawer:nth-child(4) p.tl__cart-goal__goal-check-point-title';
  const ORIGINAL_TEXT = 'Free Gift';
  const REPLACEMENT_TEXT = 'Free Giftcard';
  
  function replaceText() {
    try {
      const element = document.querySelector(TARGET_SELECTOR);
      if (element && element.textContent.trim() === ORIGINAL_TEXT) {
        element.textContent = REPLACEMENT_TEXT;
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
  
  replaceText();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceText);
  }
  window.addEventListener('load', replaceText);
  
  const observer = new MutationObserver(replaceText);
  const cartContainer = document.querySelector('.custom-cart-redesign');
  if (cartContainer) {
    observer.observe(cartContainer, { childList: true, subtree: true, characterData: true });
  }
  
  setInterval(replaceText, 2000);
})();

// Box 4 - nth-child(5)
(function() {
  'use strict';
  const TARGET_SELECTOR = '.custom-cart-redesign .tl__cart-goal__goal-check-point__drawer:nth-child(5) p.tl__cart-goal__goal-check-point-title';
  const ORIGINAL_TEXT = 'Free Gift';
  const REPLACEMENT_TEXT = 'Essentials Bag';
  
  function replaceText() {
    try {
      const element = document.querySelector(TARGET_SELECTOR);
      if (element && element.textContent.trim() === ORIGINAL_TEXT) {
        element.textContent = REPLACEMENT_TEXT;
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
  
  replaceText();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceText);
  }
  window.addEventListener('load', replaceText);
  
  const observer = new MutationObserver(replaceText);
  const cartContainer = document.querySelector('.custom-cart-redesign');
  if (cartContainer) {
    observer.observe(cartContainer, { childList: true, subtree: true, characterData: true });
  }
  
  setInterval(replaceText, 2000);
})();

 
document.addEventListener('DOMContentLoaded', function() {
  // Wait for Salepify app to load
  setTimeout(function() {
    const slider = document.querySelector('.tl__cart-goal__goal-container__drawer');
    if (!slider) {
      console.log('Slider not found, retrying...');
      setTimeout(arguments.callee, 500);
      return;
    }
    
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', function(e) {
      isDown = true;
      slider.style.cursor = 'grabbing';
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      e.preventDefault();
    });

    slider.addEventListener('mouseleave', function() {
      isDown = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mouseup', function() {
      isDown = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2.5; // Smooth drag
      slider.scrollLeft = scrollLeft - walk;
    });
    
    console.log('✅ Mouse drag enabled');
  }, 1000); // Wait for app to load
});

// Also run when cart opens
document.addEventListener('cart:updated', function() {
  setTimeout(function() {
    const slider = document.querySelector('.tl__cart-goal__goal-container__drawer');
    if (!slider) return;
    
    // Re-attach listeners
    slider.addEventListener('mousedown', function(e) {
      let isDown = true;
      slider.style.cursor = 'grabbing';
      let startX = e.pageX - slider.offsetLeft;
      let scrollLeft = slider.scrollLeft;
      
      const moveHandler = function(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2.5;
        slider.scrollLeft = scrollLeft - walk;
      };
      
      const upHandler = function() {
        isDown = false;
        slider.style.cursor = 'grab';
        document.removeEventListener('mousemove', moveHandler);
        document.removeEventListener('mouseup', upHandler);
      };
      
      document.addEventListener('mousemove', moveHandler);
      document.addEventListener('mouseup', upHandler);
    });
  }, 500);
});
